import type { JSX } from 'react';

import { Trans, t } from '@grafana/i18n';
import { Alert, TextLink } from '@grafana/ui';

export interface Props {
  variant?: 'info' | 'error';
}

const ActionMessage = () => {
  return (
    <Trans i18nKey="reporting.errors.action-message">
      Please contact your Grafana administrator to set up the service.
    </Trans>
  );
};

const NoRendererInfoMessage = (): JSX.Element => {
  return (
    <Trans i18nKey="reporting.errors.no-renderer-description">
      To generate PDF reports, you must set up the{' '}
      <TextLink href="https://grafana.com/docs/grafana/latest/setup-grafana/image-rendering/" external>
        Grafana Image Renderer service
      </TextLink>
      .
    </Trans>
  );
};

export const NoRendererInfoBox = ({ variant = 'info' }: Props): JSX.Element => {
  return (
    <Alert title={t('reporting.errors.no-renderer-title', 'Image renderer service not configured')} severity={variant}>
      <NoRendererInfoMessage /> <br />
      <ActionMessage />
    </Alert>
  );
};

const OldRendererInfoMessage = (): JSX.Element => {
  return (
    <Trans i18nKey="reporting.errors.old-renderer-description">
      To generate CSV files, you must update the{' '}
      <TextLink href="https://grafana.com/docs/grafana/latest/setup-grafana/image-rendering/" external>
        Grafana Image Renderer service
      </TextLink>
      .
    </Trans>
  );
};

export const OldRendererInfoBox = (): JSX.Element => {
  return (
    <Alert
      title={t('reporting.errors.old-renderer-title', 'You are using an old version of the image renderer service')}
      severity="warning"
    >
      <OldRendererInfoMessage /> <br />
      <ActionMessage />
    </Alert>
  );
};
